export default [
	{
		path: '/plugin-uninstall',
		name: 'PluginUninstall',
		component: () => import('@/views/uninstall/PluginUninstall.vue'),
		meta: {
			layout: 'Default',
			abilities: ['*']
		}
	},
]